var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08071 10.1228C10.9798 10.1228 12.5257 8.5899 12.5257 6.7069C12.5257 4.82389 10.9798 3.29102 9.08071 3.29102C7.18167 3.29102 5.63574 4.82389 5.63574 6.7069C5.63574 8.5899 7.18167 10.1228 9.08071 10.1228Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7555 21.4385H2.19092V19.9249C2.19092 18.123 2.89929 16.383 4.18039 15.1106C5.44642 13.8382 7.17967 13.1123 8.97321 13.1123C10.7667 13.1123 12.5 13.8232 13.766 15.1106C15.0321 16.383 15.7555 18.123 15.7555 19.9249V21.4385Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1099 3.29102C16.0292 3.29102 16.9013 3.65608 17.545 4.29228C18.1867 4.93063 18.5548 5.79528 18.5548 6.7069C18.5548 7.61851 18.1867 8.48317 17.545 9.12151C16.9013 9.75772 16.0292 10.1228 15.1099 10.1228",
    stroke: "#33D76F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4785 13.5391C18.8048 14.0152 19.9417 14.8777 20.7534 15.9942C21.563 17.1087 22 18.4323 22 19.788V21.4383H19.6618",
    stroke: "#33D76F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.71b2e38d702627305f09490a999032e4.svg";
export { ForwardRef as ReactComponent };